<template>
  <el-row :gutter="5">
    <el-progress :percentage="percentage" :show-text="false"></el-progress>
    <br>
    <el-alert v-if="percentage >= 100"
      description="Importação finalizada com sucesso!"
      type="success"
      :closable="false"></el-alert>
    <el-row :gutter="5" style="margin-top: 50px">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="6" :offset="11" style="display: flex; justify-content: center">
        <el-button type="warning" @click="reload()">Executar novamente</el-button>
        <el-button type="success" @click="reset()">Finalizar</el-button>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { PrepostService } from "@/services/customers/prepost.services";

export default {
  name: "ResultingPrespost",
  props: ["records", "customer"],
  methods: {
    reset() {
      this.$emit('reset');
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status === "Erro") {
        return "warning-row";
      } else if (row.status === "Sucesso") {
        return "success-row";
      }
      return "";
    },
    parse(data) {
      const vm = this;
      let prepostData = {
        prepost: {
          cardpost: "",
          customer: "",
          service: "",
          value: 0,
          sender: {},
          delivery: {},
          contact: {},
          object: {},
          complement: {},
          dc: [],
        },
      };
      if (data.CARTAO) {
          prepostData.prepost.cardpost = data.CARTAO;
      }

      if (data.CEP_REM && data.CEP_REM.length < 8) {
        data.CEP_REM = data.CEP_REM.padStart(8, "0");
      }

      prepostData.prepost.sender = {
        cep: data.CEP_REM ? data.CEP_REM : '',
        contact: data.NOME_REM ? data.NOME_REM : "",
        address: data.ENDERECO_REM ? data.ENDERECO_REM : '',
        neighborhood: data.BAIRRO_REM ? data.BAIRRO_REM : '',
        city: data.CIDADE_REM ? data.CIDADE_REM : '',
        state: data.UF_REM ? data.UF_REM : '',
        number: data.NUMERO_REM ? data.NUMERO_REM : "",
        extent: data.COMPLEMENTO_REM ? data.COMPLEMENTO_REM : "",
      };

      if (data.PRODUTO_DC) {
        const productList = data.PRODUTO_DC.split('#');
        const quantityList = data.QUANTIDADE_DC.split('#');
        const valueList = data.VALOR_DC.split('#');
        if (productList.length !== quantityList.length || productList.length !== valueList.length) {
          prepostData.error = `CAMPO "DC PRODUTO" NÃO COMPATIVEL COM OS CAMPOS "DC QTD" E "DC VALOR", VERIFIQUE SE O SEPARADOR # DOS CAMPOS`;
        } else {
          for (let i = 0; i < productList.length; i++) {
            const quantity = quantityList[i].replace(',', '.');
            const value = valueList[i].replace(',', '.');
            prepostData.prepost.dc.push({
              content: productList[i],
              quantity: isNaN(+quantity) ? 1 : +quantity,
              value: isNaN(+value) ? 1 : +value,
            })
          }
        }
      }

      if (data.CEP && data.CEP.length < 8) {
        data.CEP = data.CEP.padStart(8, "0");
      }
      prepostData.prepost.delivery = {
        delivery: null,
        branch: null,
        department: data.DEPARTAMENTO ? data.DEPARTAMENTO : "",
        cep: data.CEP,
        contact: "",
        address: data.ENDERECO ? data.ENDERECO : "",
        neighborhood: data.BAIRRO ? data.BAIRRO : "",
        city: data.CIDADE ? data.CIDADE : "",
        state: data.UF ? data.UF : "",
        number: data.NUMERO ? data.NUMERO : "",
        extent: data.COMPLEMENTO ? data.COMPLEMENTO : "",
        name: data.DESTINATARIO ? data.DESTINATARIO : "",
      };
      prepostData.prepost.contact = {
        save: "",
        invoice: data.NOTA ? data.NOTA : "",
        request: data.PEDIDO ? data.PEDIDO : "",
        care: data.AC ? data.AC : "",
        mail: data.EMAIL_DESTINO ? data.EMAIL_DESTINO : "",
        phone: data.TELEFONE_DESTINO ? data.TELEFONE_DESTINO : "",
        federalid: data.CPF_CNPJ ? data.CPF_CNPJ : "",
        observation: data.OBSERVACAO ? data.OBSERVACAO : "",
        whatsapp: data.WHATSAPP && (data.WHATSAPP.toUpperCase() == 'S' || data.WHATSAPP.toUpperCase() == 'SIM' || data.WHATSAPP == '1') ? true : false,
      };

      prepostData.prepost.object = {
        package: data.EMBALAGEM ? data.EMBALAGEM : "",
        mdp: "",
        quantity: 1,
        ar: data.AR && (data.AR.toUpperCase() == 'S' || data.AR.toUpperCase() == 'SIM' || data.AR == '1') ? true : false,
        ownhand: data.MP && (data.MP.toUpperCase() == 'S' || data.MP.toUpperCase() == 'SIM' || data.MP == '1') ? true : false,
        reg: data.REGISTRADO ? data.REGISTRADO : "",
        urg: data.URGENTE ? data.URGENTE : "",
        weight: data.PESO,
        type: data.TIPO ? data.TIPO : "",
        object: data.OBJETO ? data.OBJETO : "",
      };

      prepostData.prepost.complement = {
        type: data.TIPO ? data.TIPO : "001",
        width: data.LARGURA ? +data.LARGURA : 0,
        height: data.ALTURA ? +data.ALTURA : 0,
        length: data.COMPRIMENTO ? +data.COMPRIMENTO : 0,
        value: data.VALOR_DECLARADO ? data.VALOR_DECLARADO : 0,
      };

      prepostData.prepost.service = data.SERVICO;
      prepostData.prepost.customer = vm.customer;
      return prepostData.prepost;

    },
    execute() {
      const data = this.records[this.count];
      console.log('execute', this.count);
      if (data) {
        this.save(data);
      }
    },
    reload() {
      this.count = 0;
      this.execute();
    },
    save(record) {
      this.count++;
      const prepostData = this.parse(record);

      const loading = this.$loading(this.$options.loading);
      PrepostService.simple(prepostData) 
        .then((response) => {
          console.log('response', response)
          console.log('this.count', this.count, prepostData);
          if (this.count < this.records.length) this.execute();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: `Prepostagem ${prepostData.object.object} com erro: ${error}`,
            timeout: 5000,
          });
        })
        .finally(() => loading.close());

    }
  },
  computed: {
    percentage() {
      return (+this.count / +this.records.length) * 100;
    },
    format() {
      return `${+this.percentage.toFixed(0)}%`;
    }
  },
  data() {
    return {
      count: 0,
      tableResult: [],
    };
  },
  mounted() {
    this.execute();
  },
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
